/**
 * Toggle's the submenu when the user clicks on a parent menu link item,
 * when clicking somewhere else it hides the submenu again.
 */
const menuInit = () => {
  const dropdowns = document.querySelectorAll('.menu .menu__item--has-children');
  const active = 'menu__item--active';

  const closeDropdowns = (dropdown?: HTMLLIElement) => {
    [...dropdowns]
      .filter((item) => {
        if (dropdown === undefined) return item;
        return item !== dropdown;
      })
      .forEach((item: HTMLLIElement) => {
        item.classList.remove(active);
      });
  };

  const handleClick = () => {
    document.removeEventListener('click', handleClick);
    closeDropdowns();
  };

  [...dropdowns].forEach((dropdown: HTMLLIElement) => {
    const children = dropdown.querySelectorAll(':scope > .menu__link');

    children.forEach((child: HTMLAnchorElement) => {
      child.addEventListener('click', (e: Event) => {
        e.preventDefault();

        // Does the parent menu item of the click child
        // have the 'menu__item--active' class before it is toggled?
        const hasActiveClass = dropdown.classList.contains(active);

        // Close all dropdown except the one given as argument
        closeDropdowns(dropdown);

        // Add active class to current click
        dropdown.classList.toggle(active);

        if (hasActiveClass) {
          document.removeEventListener('click', handleClick);
        } else {
          document.addEventListener('click', handleClick);
        }
      });
    });
  });
};

export default menuInit;
